import { render, staticRenderFns } from "./fieldSwitch.vue?vue&type=template&id=125ead57&lang=pug&"
import script from "./fieldSwitch.vue?vue&type=script&lang=js&"
export * from "./fieldSwitch.vue?vue&type=script&lang=js&"
import style0 from "./fieldSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports